import { render, staticRenderFns } from "./BCXHelpTextTriggerIcon.vue?vue&type=template&id=06baf113&scoped=true"
import script from "./BCXHelpTextTriggerIcon.vue?vue&type=script&lang=ts"
export * from "./BCXHelpTextTriggerIcon.vue?vue&type=script&lang=ts"
import style0 from "./BCXHelpTextTriggerIcon.vue?vue&type=style&index=0&id=06baf113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06baf113",
  null
  
)

export default component.exports